import { DOCUMENT } from '@angular/common';
import { inject, InjectionToken, signal } from '@angular/core';
import { createInjectionToken } from 'ngxtension/create-injection-token';

export const [injectAppStale, provideAppStale] = createInjectionToken(() => signal(false));

/**
 * Injected callable that reloads the app. Exists as a token so specs can
 * substitute a spy without monkey-patching `location.reload` (which is
 * non-configurable in headless Chrome).
 */
export const RELOAD_APP = new InjectionToken<() => void>('RELOAD_APP', {
  providedIn: 'root',
  factory: () => {
    const doc = inject(DOCUMENT);
    return () => doc.location.reload();
  },
});
